import { TapTheme } from '@tapresearch/ui/components';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button as ChakraButton,
} from '@chakra-ui/react';

import React from 'react';
import { popupContext } from '../PopupProvider';
import { AlertPopupProps } from './useAlertPopup';

export function AlertPopup({
  title = 'Error',
  description = 'There was an error',
  buttonText = 'Accept',
  contentBoxProps = {},
  ...alertDialogProps
}: AlertPopupProps) {
  const acceptRef = React.useRef();
  const [isOpen, setIsOpen] = React.useState(true);
  const onClose = React.useCallback(() => setIsOpen(false), [setIsOpen]);

  const { resetPopup } = React.useContext(popupContext);

  React.useLayoutEffect(() => {
    if (isOpen === false) {
      setTimeout(() => resetPopup(), 600);
    }
  }, [isOpen, resetPopup]);

  const onAcceptclick = React.useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <AlertDialog
      {...alertDialogProps}
      isOpen={isOpen}
      leastDestructiveRef={acceptRef}
      onClose={onAcceptclick}
    >
      <AlertDialogOverlay>
        <AlertDialogContent {...contentBoxProps}>
          <AlertDialogHeader
            data-testid="alert-popup-title"
            fontSize="lg"
            fontWeight="bold"
          >
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>{description}</AlertDialogBody>

          <AlertDialogFooter>
            <ChakraButton
              data-testid="alert-popup-accept"
              ref={acceptRef}
              onClick={onAcceptclick}
              backgroundColor={TapTheme.colors.blue[500]}
              color={TapTheme.colors.white}
              _hover={{
                backgroundColor: TapTheme.colors.blue[300],
              }}
            >
              {buttonText}
            </ChakraButton>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
